import { Truck } from "lucide-react";

export function ProveedorArrendamientoBadge({ testid = "badge-proveedor-arrendamiento" }) {
  return (
    <span data-testid={testid}
      className="inline-flex items-center gap-1 rounded-full border border-teal-200 bg-teal-50 px-2 py-0.5 text-[10.5px] font-semibold text-teal-800">
      <Truck className="h-3 w-3" /> Proveedor de arrendamiento
    </span>
  );
}
